module.exports = __webpack_public_path__ + "static/media/cloud-img-3.f4d87849.png";